import React from "react";
import { useFormatPrice } from "hooks";

const CostWidget = ({ paymentStatus, totalOrderAmt, totalDue }) => {
  const formatPrice = useFormatPrice();

  return (
    <div className="flex flex-col w-fit">
      <div className="text-[14px]">
        <span className=" uppercase">Total Cost:</span>
        <span className="font-semibold">
          &nbsp;{formatPrice(totalOrderAmt || 0)}
        </span>
      </div>

      {paymentStatus === 1 && (
        <div className="text-[14px] border-t text-red-500">
          <span className=" uppercase">Total Due:</span>
          <span className="font-semibold">
            &nbsp;{formatPrice(totalDue || 0)}
          </span>
        </div>
      )}
    </div>
  );
};

export default CostWidget;
